angular.module('wbDashboard').controller('PlansDetailDisablePortfolioplusControllerAurea',
    ['$scope', '$q', '$uibModal', '$window', '$timeout', 'Message', 'User', 'PlanService', 'RiskScore', 'Milestone', 'milestoneCountResolve', 'PlanningService',
function ($scope, $q, $uibModal, $window, $timeout, Message, User, PlanService, RiskScore, Milestone, milestoneCountResolve, PlanningService) {

    $scope.customMilestones = null;
    $scope.data = {
        ms: null
    };
    $scope.Object = Object;
    $scope.pageData.sticky = 0;

    if (!milestoneCountResolve) {
        $scope.$state.go('.', {page: "delete", msId: null});
        $timeout(function () {
            $scope.disablePortfoliosModal();
        });
    } else if ($scope.$stateParams.page !== "confirm") {
        $scope.$state.go('.', {page: "confirm", msId: null}, {location: 'replace'});
    }

    $scope.$watch(function() { return User.getMilestones(); }, function(milestones) {
        if (milestones) {
            $scope.customMilestones = {};
            angular.forEach(milestones, function(ms) {
                if (ms.allocation.allocation_slug) {
                    var cm = angular.copy(ms);
                    cm.allocation.allocation_slug = null;
                    cm.allocation.allocation_start = cm.allocation.recommendation.allocation_start;
                    cm.allocation.allocation_end = cm.allocation.recommendation.allocation_end;
                    //since user has specifically set cash allocations, don't set them to the recommended
                    $scope.customMilestones[ms.id] = cm;
                }
            });
        }
    }, true);

    $scope.disablePortfoliosModal = function() {
        if ($scope.$stateParams.page !== 'delete') {
            $scope.$state.go(".", {page: "delete"});
        }

        var modalInstance = $uibModal.open({
            templateUrl: "modal-portfolioplus-disable-confirm.tpl.html",
            size: 'md',
            scope: $scope,
            windowClass: 'plan-info-confirm-modal'
        });

        modalInstance.result.then(function () {
            return $scope.disablePortfolios();
        }).catch(function () {
            if ($scope.customMilestones.length) {
                $window.history.back();
            } else {
                if (!$scope.pageData.errorMsg) {
                    $window.history.back();
                }
            }
        }).finally(function() {

        });
    };

    $scope.disablePortfolios = function() {
        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = false;
        return $q.when(1).then(function() {
            var msRequests = [];
            angular.forEach($scope.customMilestones, function (ms, msId) {
                var data = {
                    allocation_start: ms.allocation.allocation_start,
                    allocation_end: ms.allocation.allocation_end,
                    cash_start: ms.allocation.cash_start,
                    cash_end: ms.allocation.cash_end,
                };
                if (ms.type === 'build_wealth' || ms.type_account) {
                    data.allocation_end = ms.allocation.allocation_start;
                    data.cash_end = ms.allocation.cash_start;
                }
                var promise = PlanService.user.setMilestoneAllocation(ms.id, data);
                msRequests.push(promise);
            });
            return $q.all(msRequests);
        }).catch(function(response) {
            Message.set({
                text: "There was a problem replacing Portfolios with " + PlanService.user.getPortfolioName("1.0") + " Portfolio",
                type: "danger"
            });
            throw response;
        }).then(function() {
            return $scope.disablePlan($scope.plan);
        }).catch(function(response) {
            $scope.pageData.errorMsg = true;
        }).then(function() {
            return $q.all([
                PlanService.user.retrievePortfolios(null, true),
                //need to remove all data since positions could have changed
                User.retrieveAllMilestones(true, true)
            ]);
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.goToRiskSurvey = function() {
        $scope.$state.go('base.planning.recommendation',{slugOrId: PlanningService.riskInfo.surveyId, riskReturnTo: 'base.plans.custom.portfolioplus.disable'});
    };

    $scope.goNextPage = function() {
        var page = null;
        switch ($scope.$stateParams.page) {
            case 'portfolio-type':
                Milestone.updatePortfolioType($scope.data.ms.extra.portfolio_type);
                switch ($scope.data.ms.extra.portfolio_type) {
                    case 'stocks_bonds_cash':
                        page = 'cash-amount';
                        break;
                    case 'stocks_bonds':
                        page = 'allocation-start';
                        break;
                    case 'cash':
                        page = 'confirm';
                        break;
                }
                break;
            case 'cash-amount':
                page = 'allocation-start';
                break;
            case 'allocation-start':
                page = 'cash-amount-end';
                if ($scope.data.ms.type === 'build_wealth' || $scope.data.ms.type_account) {
                    page = 'confirm';
                }
                break;
            case 'cash-amount-end':
                page = 'allocation-end';
                break;
            case 'allocation-end':
                page = 'review-glide';
                Milestone.retrieveGlideFuture();
                break;
            case 'review-glide':
                page = 'confirm';
                break;
        }

        if (page) {
            $scope.goToPage(page);
        }
    };
    $scope.goToPage = function(params, options = {}) {
        if (typeof params === 'string') {
            params = {page: params};
        }
        if (params.page === 'confirm') {
            params.msId = null;
        }
        return $scope.$state.go('.', params, options);
    };

    $scope.viewPortfolioAllocation = function(allocation, cash) {
        var portfolio = angular.copy($scope.riskPortfolios[allocation.toFixed(1)]);

        portfolio = RiskScore.formatPortfolio(portfolio, cash, true);
        portfolio.total_value = 0;
        $scope.riskAllocation = portfolio;

        $scope.goToDetail();
    };

    $scope.goToDetail = function() {
        $scope.$state.go(".",{page:'allocation-detail'});
    };


    /*********************************
     ******* ALLOCATION PAGES ********
     *********************************/
    $scope.$watchGroup(['data.ms.extra.cash_start_percent','data.ms.extra.cash_end_percent'], function(data) {
        var [startPercent, endPercent] = data;
        if (startPercent || endPercent || endPercent === 0) {
            $scope.data.ms.allocation.cash_start = getCashRatio(startPercent);
            $scope.data.ms.allocation.cash_end = getCashRatio(endPercent);

            if ($scope.data.ms.type === 'build_wealth' || $scope.data.ms.type_account) {
                $scope.data.ms.allocation.cash_end = $scope.data.ms.allocation.cash_start;
            }

        }
        function getCashRatio(percent) {
            return (percent || percent === 0) ? percent/100 : null;
        }
    });

    $scope.$watchGroup(['data.ms.extra.allocation_start_value','data.ms.extra.allocation_end_value'], function(data) {
        var [startValue, endValue] = data;

        if (startValue || startValue === 0) {
            $scope.data.ms.allocation.allocation_start = startValue.toFixed(1);
        }
        if (endValue || endValue === 0) {
            $scope.data.ms.allocation.allocation_end = endValue.toFixed(1);
        }
    });

    var transitionDeregisterHook = {};
    transitionDeregisterHook[0] = $scope.$transitions.onStart({ to: "base.plans.custom.portfolioplus.disable.**" }, function(trans) {
        var ms;
        var msIdOld = trans.params('from').msId;
        var msIdNew = trans.params('to').msId;

        if (!msIdNew && msIdOld && $scope.data.ms && msIdOld === $scope.data.ms.id) {
            //going back to main page, update milestone with changes from milestone controller
            ms = $scope.customMilestones[msIdOld];
            ms.allocation.allocation_start = $scope.data.ms.allocation.allocation_start;
            ms.allocation.allocation_end = $scope.data.ms.allocation.allocation_end;
            ms.allocation.cash_start = $scope.data.ms.allocation.cash_start;
            ms.allocation.cash_end = $scope.data.ms.allocation.cash_end;
            $scope.data.ms = null;
        }
        if (msIdNew && msIdOld !== msIdNew) {
            //going to edit milestone allocation pages
            //set up milestone controller with selected milestone
            ms = $scope.customMilestones[msIdNew];

            Milestone.clearMS();
            Milestone.setMilestoneUpdateFromObject(ms);
            $scope.data.ms = Milestone.ms;
        }
    });
    transitionDeregisterHook[1] = $scope.$transitions.onSuccess({ to: $scope.$state.current.name+".**" }, function(trans) {
        var page = trans.params('to').page;

        $scope.pageData.page = page;
        if (page === 'portfolio-type') {
            Milestone.getGlidePortfolioTypeRecommend();
        }
        //trigger hl-sticky options a second after page load to redraw item;
        $timeout(function () {$scope.pageData.sticky++;}, 10);
        $timeout(function () {$scope.pageData.sticky++;}, 100);
        $timeout(function () {$scope.pageData.sticky++;}, 500);
        $timeout(function () {$scope.pageData.sticky++;}, 1000);
    });
    transitionDeregisterHook[2] = $scope.$transitions.onBefore({ to: "base.planning.**" }, function(trans) {
        //to prevent using forward/back and losing the params when going to the survey
        let orig = trans.targetState();
        let toParams = orig.params();
        if (!toParams.riskReturnTo) {
            toParams.riskReturnTo = 'base.plans.custom.portfolioplus.disable';
            return trans.router.stateService.target(orig.identifier(), toParams, orig.options());
        }
    });


    $scope.$on('$destroy', function() {
        for (let i = 0; i<=2; i++) {
            if (transitionDeregisterHook[i]) {
                transitionDeregisterHook[i]();
            }
        }
    });

}]);
